import { DrfqLeg } from '#/unified-rfqs/entities/drfq/domain';
import { processLeg } from '#/unified-rfqs/ui/drfq/legs-table-functions';

export default function legsView(legs: readonly DrfqLeg[]) {
  return legs.map((leg, index) => processLeg(leg, index));
}
